import {remCalc} from '../../_utils'

export default {
    baseStyle: {
        backgroundContainer: {
            w: '100%',
            justifyContent: 'center',
        },
        outerContainer: {
            layerStyle: 'full-width',
            width: '100%',
            overflowX: 'auto',
            flexShrink: 0,
            flexDir: 'column',
            pt: remCalc(8),
            pb: remCalc(24),
        },
        elementsGrid: {
            columns: {base: 2, md: 4, lg: 7},
            spacing: {base: remCalc(8), lg: remCalc(32)},
            px: {base: remCalc(16), md: remCalc(24)},
            justifyContent: {base: 'stretch', md: 'start'},
        },
        elementContainer: {
            display: 'flex',
            flexDir: 'column',
            gap: {base: remCalc(4), md: remCalc(16)},
            textAlign: 'center',
            w: '100%',
            maxW: {md: remCalc(168)},
            mx: 'auto',
        },
        elementImage: {
            w: '100%',
            aspectRatio: 1 / 1,
            objectFit: 'cover',
            mx: 'auto',
        },
        headerLabel: {
            py: {
                base: remCalc(16),
                md: remCalc(16),
                lg: remCalc(40),
            },
            px: {
                base: remCalc(16),
                md: remCalc(24),
            },
            position: 'sticky',
            textStyle: 'head-large',
            fontWeight: '500',
            noOfLines: 2,
            mb: {base: 6, md: 6, lg: 6},
        },
        showAllButton: {
            color: '#0C2340',
            textStyle: 'body-medium',
            fontStyle: 'normal',
            fontWeight: 600,
            variant: 'link',
            alignItems: 'center',
            display: 'inline-flex',
            gap: 2,
        },
        itemLabel: {
            textAlign: 'center',
            textStyle: 'head-xxsmall',
            fontStyle: 'normal',
            fontWeight: 600,
        },
    },
    variants: {
        greyBackgroundVariant: {
            backgroundContainer: {
                background: 'background.light',
            },
            outerContainer: {
                layerStyle: 'full-width',
                width: '100%',
                overflowX: {base: 'auto', md: 'auto', lg: 'hidden'},
                flexShrink: 0,
                background: 'background.light',
                flexDir: 'column',
                pt: remCalc(80),
                pb: remCalc(120),
            },
        },
    },
}
